import * as Sentry from '@sentry/browser';
import * as React from 'react';
import { ErrorScreen } from '.';

interface IErrorState {
  error: Error | null | undefined;
}

class ErrorBoundary extends React.Component<{}, IErrorState> {
  public state = { error: null };

  public componentDidCatch(error: Error | null, errorInfo: React.ErrorInfo) {
    // tslint:disable-next-line:no-console
    console.log(`ErrorBoundry is handing error`, error);

    this.setState({ error });

    Sentry.withScope(scope => {
      Object.keys(errorInfo).forEach(key => {
        // @ts-ignore
        scope.setExtra(key, errorInfo[key]);
      });
      Sentry.captureException(error);
    });
  }

  public render() {
    if (this.state.error) {
      // render fallback UI
      return <ErrorScreen />;
    } else {
      // when there's not an error, render children untouched
      return this.props.children;
    }
  }
}

export default ErrorBoundary;
